import type { ActionSurface } from "../types";

/** Kebab / context menus — left rail, workspace list/grid, canvas right-click. */
export const FILE_RECORD_MENU_SURFACES: readonly ActionSurface[] = [
  "left-rail",
  "main-view",
  "context-menu",
];

/** Icon / utility surfaces — canvas floating toolbar and file detail pane header. */
export const FILE_RECORD_TOOLBAR_SURFACES: readonly ActionSurface[] = [
  "floating-toolbar",
  "pane-header",
];

export const FILE_RECORD_MENU_AND_TOOLBAR_SURFACES = [
  ...new Set<ActionSurface>([
    ...FILE_RECORD_MENU_SURFACES,
    ...FILE_RECORD_TOOLBAR_SURFACES,
  ]),
] as const satisfies readonly ActionSurface[];

export const FILE_RECORD_COPY_TO_WORKSPACE_SURFACES = [
  ...new Set<ActionSurface>([...FILE_RECORD_MENU_SURFACES, "floating-toolbar"]),
] as const satisfies readonly ActionSurface[];

/** Canvas floating toolbar and file detail pane header. */
export const FILE_RECORD_DETAIL_SURFACES: readonly ActionSurface[] = [
  ...FILE_RECORD_TOOLBAR_SURFACES,
];
